<div class="kl-detail-filter">
  <kl-detail-filter-shell
    [loading]="loading()"
    [alertShow]="alertShow()"
    [alertMessage]="alertMessage()"
    [middleTitleKey]="middleTitleKey()"
    [rightTitleKey]="rightTitleKey()"
    [applyLabelKey]="applyLabelKey()"
    [clearLabelKey]="clearLabelKey()"
    [closeLabelKey]="closeLabelKey()"
    [showSaveAsPlaceholder]="showSaveAsPlaceholder()"
    [saveAsPlaceholderLabelKey]="saveAsPlaceholderLabelKey()"
    [showRight]="showSaved()"
    (apply)="onApply()"
    (clear)="onClear()"
    (close)="onClose()"
    (alertClose)="onAlertClose()">
    <div klDetailFilterLeft class="kl-detail-filter__left">
      <ng-content select="[klDetailFilterLeft]" />
    </div>

    <div klDetailFilterMiddle class="kl-detail-filter__middle">
      <div class="kl-detail-filter__values-divider" role="separator"></div>
      @if (chipRows().length === 0) {
        <p class="kl-detail-filter__values-empty">{{ middleTitleKey() | translate }} — {{ 'no_data' | translate }}</p>
      } @else {
        <ul class="kl-detail-filter__value-list">
          @for (row of chipRows(); track row.id) {
            <li class="kl-detail-filter__value-row">
              <span class="kl-detail-filter__value-text">
                <span class="kl-detail-filter__value-label">{{ row.labelKey | translate }}:</span>
                {{ row.display }}
              </span>
              <p-button
                type="button"
                icon="ph ph-trash"
                [text]="true"
                rounded="true"
                severity="danger"
                [attr.aria-label]="'delete' | translate"
                (onClick)="removeChip.emit(row.id)" />
            </li>
          }
        </ul>
      }
    </div>

    @if (showSaved()) {
      <div klDetailFilterRight class="kl-detail-filter__saved">
        <p class="kl-detail-filter__saved-hint">{{ rightTitleKey() | translate }}</p>
        @if (savedRows().length === 0) {
          <p class="kl-detail-filter__saved-placeholder">{{ 'no_data' | translate }}</p>
        } @else {
          <ul class="kl-detail-filter__saved-list">
            @for (item of savedRows(); track item.id) {
              <li
                class="kl-detail-filter__saved-row"
                [class.kl-detail-filter__saved-row--active]="selectedSavedId() === item.id">
                <button type="button" class="kl-detail-filter__saved-row-btn" (click)="selectSaved.emit(item)">
                  <span class="kl-detail-filter__saved-title">{{ item.title }}</span>
                  <small class="kl-detail-filter__saved-scope">{{ item.scopeText }}</small>
                </button>
                <p-button
                  type="button"
                  size="small"
                  icon="ph ph-trash"
                  [outlined]="true"
                  rounded="true"
                  severity="secondary"
                  class="kl-detail-filter__saved-delete-btn"
                  [disabled]="designBusy()"
                  [attr.aria-label]="'delete' | translate"
                  (onClick)="deleteSaved.emit(item)" />
              </li>
            }
          </ul>
        }

        <div class="kl-detail-filter__saved-actions">
          <p-button
            type="button"
            size="small"
            severity="secondary"
            [label]="'save_new_design' | translate"
            [disabled]="designBusy()"
            (onClick)="saveNewDesign.emit()" />
          <p-button
            type="button"
            size="small"
            severity="secondary"
            [label]="'edit_design_filter' | translate"
            [disabled]="designBusy() || updateSavedDisabled()"
            (onClick)="updateActiveDesign.emit()" />
        </div>
      </div>
    }
  </kl-detail-filter-shell>
</div>
